<ion-app
    [ngClass]="{
        '--inside-iframe': isInIframe,
        '--not-inside-iframe': !isInIframe,
        '--touchable-screen': isTouchScreen,
        '--non-touchable-screen': !isTouchScreen,
    }"
>
    <ion-router-outlet>
        <div class="--root-loading"></div>
    </ion-router-outlet>
</ion-app>
